"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _react = _interopRequireWildcard(require("react"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _Label = _interopRequireDefault(require("./Label"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _useDebounce = _interopRequireDefault(require("../../hooks/useDebounce"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RadioInput = function RadioInput(props) {
  var id = props.id,
      _props$value = props.value,
      value = _props$value === void 0 ? "" : _props$value,
      onChange = props.onChange,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? [] : _props$errors,
      _props$validations = props.validations,
      validations = _props$validations === void 0 ? [] : _props$validations,
      errorHandler = props.errorHandler,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      customLabel = props.customLabel,
      fieldDescription = props.fieldDescription,
      labelTooltip = props.labelTooltip,
      requiredSelection = props.requiredSelection,
      requiredSelectionErrorMessage = props.requiredSelectionErrorMessage,
      t = props.t;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      inputToValidate = _useState2[0],
      setInputToValidate = _useState2[1];

  var debouncedValue = (0, _useDebounce.default)(inputToValidate, 100);

  if (requiredSelection) {
    validations.push('REQUIRED_SELECTION');
  }

  var inputChangeHandler = function inputChangeHandler(id, val) {
    setInputToValidate(value);
    onChange(id, val);
  };

  var renderOptions = function renderOptions(options) {
    return options.map(function (option) {
      return _react.default.createElement(_FormControlLabel.default, {
        key: option.value,
        value: option.value,
        control: _react.default.createElement(_Radio.default, {
          checked: value === option.value,
          disabled: disabled
        }),
        label: t(option.label)
      });
    });
  };

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validations,
      errorHandler: errorHandler,
      requiredSelection: requiredSelection,
      requiredSelectionErrorMessage: requiredSelectionErrorMessage,
      id: id
    });
  };

  (0, _react.useEffect)(function () {
    if (value) setInputToValidate(value);
  }, [value, disabled]);
  (0, _react.useEffect)(function () {
    inputValidation(debouncedValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);
  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_RadioGroup.default, {
    name: value,
    value: value,
    row: true,
    onChange: function onChange(event, value) {
      return inputChangeHandler(id, value);
    }
  }, renderOptions(options)), _react.default.createElement(_Errors.default, {
    errors: errors,
    margin: "-10px 0 10px",
    t: t
  }));
};

var _default = _react.default.memo(RadioInput);

exports.default = _default;